import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { FormattedDistance } from 'shared/units'
import { FormattedElevation } from 'shared/units'
import { FormattedMessage, injectIntl } from 'react-intl'
import fitnessLogo from 'images/sites/fitness/logo.svg'
import walkLogo from 'images/sites/walk/logo.svg'
import runLogo from 'images/sites/run/logo.svg'
import rideLogo from 'images/sites/ride/logo.svg'
import hikeLogo from 'images/sites/hike/logo.svg'
import styles from './_meta.css'
import { Row, Col } from 'react-flexbox-grid/lib'

const logos = {
  'fitness': fitnessLogo,
  'walk': walkLogo,
  'run': runLogo,
  'ride': rideLogo,
  'hike': hikeLogo,
}

export class Meta extends Component {

  static propTypes = {
    intl: PropTypes.object.isRequired,
    route: PropTypes.object.isRequired,
    site: PropTypes.shape({
      name: PropTypes.string,
      slug: PropTypes.string,
      shortName: PropTypes.string,
    }),
  }

  state = {
    notes: '',
  }

  handleChangeNotes = (e) => {
    this.setState({
      ...this.state,
      notes: e.target.value,
    })
  }

  render () {
    const { route, site } = this.props
    return (
      <div>
        <Row center='xs'>
          <Col xs={12}>
            <img className={styles.logoImage} src={logos[site.slug]} alt={site.name} />
          </Col>
        </Row>
        <Row >
          <Col xs={12}>
            <p className={styles.routeName}>{route.name}</p>
            <p className={styles.metrics}>
              <FormattedMessage
                id='routes.print.meta.distance'
                defaultMessage='Distance: {distance}'
                values={{
                  distance: <FormattedDistance digits={2} value={route.distance} />,
                }} />
            </p>
            <p className={styles.metrics}>
              <FormattedMessage
                id='routes.print.meta.elevation'
                defaultMessage='Elevation Gain: {totalAscent}'
                values={{
                  totalAscent: <FormattedElevation digits={0} value={route.total_ascent} />,
                }} />
            </p>
            <p className={styles.metrics}>
              <FormattedMessage
                id='routes.print.meta.max'
                defaultMessage='Elevation Max: {max}'
                values={{
                  max: <FormattedElevation digits={0} value={route.max_elevation} />,
                }} />
            </p>
          </Col>
          <Col xs={12}>
            <p className={styles.notesPrintLabel}>
              <FormattedMessage id='routes.print.meta.notes' defaultMessage='Notes' />
            </p>
            <textarea className={styles.notesInput} onChange={this.handleChangeNotes} />
            <p className={styles.notesPrint}>{this.state.notes}</p>
          </Col>
        </Row>
      </div>
    )
  }

}

export default injectIntl(Meta)
